<ng-container *ngIf="company">
    <app-dashboard-overview [showPlansButton]="false"></app-dashboard-overview>
    <div class="container pt--lg-60 pb--lg-48 pt--24 pb--24 ">
        <div class="mb--48 col-12" 
        isInVewport (isInViewport)="onVisibilityChanged('titleIntro',$event)" [threshold]="0.3">
            <div  class="h3 text-center fw-bold mb--24" [@fadeInUp]="{value: visibilityState['titleIntro'], params: {delay: '500ms'}}">
                Delfi.ai ora conosce il tuo business
            </div>
            <div  class="text-center" [@fadeInUp]="{value: visibilityState['titleIntro'], params: {delay: '700ms'}}">
                I dati aziendali raccolti provengono dai <b>Bilanci</b> depositati dell'azienda e da banche dati open data, Cerved e Istat
            </div>
        </div>
        <company-overview [company]="companyEureso"></company-overview>
        <company-balance [company]="companyEureso" [ateco]="companyAteco"></company-balance>
    </div>
</ng-container>
